import { Moment } from 'moment';

import { TabInfoBase } from 'app/buffer-graph/models/tab-info-base';
import {ColumnSettingsBase} from "../../../slick-grid/models/column-settings-base";
import {ItemInfo} from "../item-info";

type Data = { rows: any[], startDate: Moment, endDate?: Moment, canSend: boolean, columns: ColumnSettingsBase[] };

export class SimpleTabInfo extends TabInfoBase<Data> {
    constructor(id: string, name: string, type: string, zoomFilterField: string, data: Data, itemInfo: ItemInfo, startDate: Moment, endDate: Moment, sharedGuid: string) {
        super(name, type, zoomFilterField, data, itemInfo, startDate, endDate, sharedGuid);
        this.id = id;
    }
    public readonly id;
}



// WEBPACK FOOTER //
// ./src/app/buffer-graph/models/simple-tab/simple-tab-info.ts